const initState = {
    getById:{
        data: [],
        /**control */
        connection: false,
        error: false,
        message: "",
    },
    create:{
        result:false,
        /**control */
        connection: false,
        error: false,
        message: "",
    }
};

export default initState;